import { Injectable } from "@angular/core";
import { RECENT_DOC_API_CONSTANT } from "../constant/RECENT_DOC.constant";
import { HttpHeaders, HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class RecentDocService {
  requestOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "my-auth-token",
    }),
  };

  constructor(private httpClient: HttpClient) {}

  public getRecentDocData() {
    return this.httpClient.get(RECENT_DOC_API_CONSTANT.RECENT_OFFICE_DOC_DATA);
  }
}
